import { PayinHistory } from "@/components/payment/PayinHistory";

const PATHS = {
    list: "/partner/payin/history",
    csv: "/partner/payin/history/export.csv",
    pdf: "/partner/payin/history/export.pdf",
    verify: (id) => `/partner/payin/orders/${id}/verify`,
    receipt: (id) => `/partner/payin/orders/${id}/receipt.pdf`,
    bulkVerify: "/partner/payin/orders/verify-bulk",
    callbacks: (id) => `/partner/payin/orders/${id}/callbacks`,
    resend: (id) => `/partner/payin/orders/${id}/callbacks/resend`,
};

export default function PanelPayinHistory() {
    return (
        <div data-testid="panel-payin-history" className="p-6 space-y-2">
            <div>
                <h1 className="text-2xl font-bold">PayIn History</h1>
                <p className="text-xs text-slate-500 mt-1">Every collection order — in progress, successful, failed and cancelled</p>
            </div>
            <PayinHistory paths={PATHS} testid="ph" />
        </div>
    );
}
